/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7 9.53237C7 9.53237 13 7.49976 18 10.642M7.5 12.4997C7.5 12.4997 12.5 10.642 17 13.4997M8 15.3955C8 15.3955 12 13.9998 15.5 16.2215"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				fill="currentColor"
			/>
			<path
				d="M7 9.53262C7 9.53262 13 7.5 18 10.6423M7.5 12.5C7.5 12.5 12.5 10.6423 17 13.5M8 15.3957C8 15.3957 12 14 15.5 16.2217M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM7.24064 10.243C6.84845 10.3756 6.42251 10.1654 6.28965 9.77326C6.15675 9.38095 6.36704 8.95518 6.75936 8.82227L6.76064 8.82184C7.11822 8.70159 7.48582 8.61304 7.85391 8.53176C8.52557 8.38345 9.47301 8.22053 10.5843 8.1602C12.7986 8.03998 15.7214 8.32449 18.3991 10.0073C18.7498 10.2277 18.8554 10.6906 18.635 11.0413C18.4146 11.3921 17.9516 11.4977 17.6009 11.2773C15.2786 9.81778 12.7014 9.54747 10.6657 9.65799C9.65199 9.71302 8.78693 9.86187 8.17734 9.99648C7.86261 10.066 7.54712 10.1423 7.24064 10.243ZM7.24011 11.7965L7.23879 11.7969C6.85051 11.9412 6.65269 12.3729 6.79696 12.7612C6.94116 13.1493 7.37306 13.3469 7.76121 13.203C8.01105 13.1136 8.26893 13.0456 8.52676 12.9836C9.03189 12.8623 9.75307 12.7275 10.6068 12.677C12.318 12.5758 14.5214 12.8144 16.5979 14.1331C16.9476 14.3552 17.4111 14.2517 17.6331 13.9021C17.8552 13.5524 17.7517 13.0889 17.4021 12.8669C14.9786 11.3278 12.432 11.0664 10.5182 11.1797C9.55943 11.2364 8.74936 11.3875 8.17636 11.5251C7.86123 11.6008 7.54651 11.6843 7.2419 11.7958L7.24011 11.7965ZM8.24708 16.1038C7.85613 16.24 7.42827 16.0337 7.29187 15.6428C7.15541 15.2517 7.36183 14.824 7.75292 14.6876C8.60177 14.3947 9.50664 14.2708 10.4004 14.2265C11.9342 14.1505 13.9791 14.3679 15.9019 15.5885C16.2516 15.8105 16.3552 16.2739 16.1332 16.6236C15.9112 16.9733 15.4478 17.0769 15.0981 16.8549C13.5209 15.8538 11.8158 15.6582 10.4746 15.7246C9.72314 15.7619 8.96309 15.8652 8.24708 16.1038Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M7 9.53262C7 9.53262 13 7.5 18 10.6423M7.5 12.5C7.5 12.5 12.5 10.6423 17 13.5M8 15.3957C8 15.3957 12 14 15.5 16.2217M18 3.99927C16.3287 2.74389 14.2512 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 10.1786 21.513 8.47087 20.6622 7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M7 9.53262C7 9.53262 13 7.5 18 10.6423M7.5 12.5C7.5 12.5 12.5 10.6423 17 13.5M8 15.3957C8 15.3957 12 14 15.5 16.2217M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25Z"
				fill="currentColor"
			/>
			<path
				d="M7.24066 10.2432C6.84847 10.3758 6.42253 10.1657 6.28968 9.77348C6.15677 9.38117 6.36706 8.9554 6.75938 8.8225L6.76066 8.82206C7.11824 8.70181 7.48584 8.61326 7.85393 8.53198C8.5256 8.38367 9.47303 8.22075 10.5844 8.16042C12.7987 8.0402 15.7215 8.32471 18.3991 10.0075C18.7498 10.2279 18.8554 10.6909 18.635 11.0416C18.4146 11.3923 17.9517 11.4979 17.6009 11.2775C15.2786 9.81801 12.7014 9.54769 10.6657 9.65821C9.65202 9.71325 8.78695 9.86209 8.17736 9.9967C7.86264 10.0662 7.54714 10.1425 7.24066 10.2432Z"
				fill="currentColor"
			/>
			<path
				d="M7.23881 11.7972L7.24013 11.7967L7.24192 11.796C7.54653 11.6845 7.86125 11.6011 8.17638 11.5253C8.74938 11.3877 9.55945 11.2366 10.5182 11.1799C12.4321 11.0667 14.9786 11.328 17.4021 12.8671C17.7517 13.0891 17.8552 13.5526 17.6331 13.9023C17.4111 14.2519 16.9476 14.3554 16.598 14.1333C14.5215 12.8147 12.318 12.576 10.6068 12.6773C9.75309 12.7278 9.03191 12.8625 8.52678 12.9838C8.26895 13.0458 8.01107 13.1138 7.76123 13.2033C7.37308 13.3472 6.94118 13.1495 6.79698 12.7614C6.65272 12.3731 6.85053 11.9414 7.23881 11.7972Z"
				fill="currentColor"
			/>
			<path
				d="M8.24711 16.1041C7.85615 16.2402 7.42829 16.0339 7.29189 15.643C7.15543 15.2519 7.36185 14.8243 7.75294 14.6878C8.60179 14.3949 9.50666 14.271 10.4004 14.2267C11.9342 14.1507 13.9791 14.3681 15.902 15.5887C16.2517 15.8107 16.3552 16.2741 16.1332 16.6239C15.9112 16.9736 15.4478 17.0771 15.0981 16.8551C13.5209 15.854 11.8158 15.6584 10.4746 15.7249C9.72316 15.7621 8.96312 15.8655 8.24711 16.1041Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
